/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ItemHeartWrapper_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontProductTile_viewer$ref: FragmentReference;
export type StorefrontProductTile_viewer = {|
  +$fragmentRefs: ItemHeartWrapper_viewer$ref,
  +$refType: StorefrontProductTile_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontProductTile_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": null
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "hasUserId",
          "type": null
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'dc02e0f25895beaf6d94f824ca0cba43';
module.exports = node;
